import { gql } from '__generated__';

export default gql(`
  mutation DuplicateTicket($id: ID!) {
    duplicateTicket(id: $id) {
      id
    }
  }
`);
